module.exports = __webpack_public_path__ + "img/home-7.0eeadf97.png";